module.exports = __webpack_public_path__ + "img/docs.56f12176.svg";